import { createTheme } from "@mui/material/styles";
import { defaultTheme } from "components/Theme/Style";

const theme = createTheme(defaultTheme, {
  palette: {
    mode: "light",
    primary: { main: "#164194", dark: "#164194" },
    secondary: { main: "#222423" },
    neutral: { main: "#5c6ac4" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#65B32E",
          },
        },
      },
    },
  },
});

export default theme;
